import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import Loader from "../Loader/Loader";

import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import { FreeMode, Autoplay } from "swiper/modules";
import { LoaderContext } from "../../context/LoaderContext";
import { Helmet } from "react-helmet";

export default function ProjectsDetails() {
  const LoaderContextVarible = useContext(LoaderContext);
  const [t, i18n] = useTranslation("global");
  const params = useParams();

  const [data, setData] = useState([]);
  useEffect(() => {
    LoaderContextVarible.setLoaderProjectsDetails(true);

    fetch(`https://admin.innova.com.eg/api/project/view/${params.id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-api-token":
          "d5eab596caa0128af68cd5d2e56219c2e3945fb11c5f3fb3cc4245576bbd5c387aab3f1f3fd9a89ecd96cc35d6a9574e31b0c669201df343d299eae97b64f618",
        "Accept-Language": i18n.language,
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        setData(data.data);
        setTimeout(() => {
          LoaderContextVarible.setLoaderProjectsDetails(false);
        }, 1000);
      })
      .catch((error) => {
        setTimeout(() => {
          LoaderContextVarible.setLoaderProjectsDetails(false);
        }, 1000);
      });
  }, [params.id, i18n.language]);

  return (
    <>
      <Helmet>
        <title>INNOVA | {data?.title || ""}</title>
      </Helmet>
      {LoaderContextVarible.loaderProjectsDetails ? (
        <Loader />
      ) : (
        <section id="NewsDetails" className="mt-5">
          <div className="container mt-3">
            <div className="position-relative main-banner">
              <h2 className="main-banner-h2">
                {t("ProjectsSecHome.projects.title")}
              </h2>
              <p className="main-banner-p">
                {t("ProjectsSecHome.projects.subtitle")}
              </p>
            </div>
            <div className="all-news">
              <Swiper
                dir="ltr"
                className="mySwiper"
                grabCursor={true}
                autoplay={{
                  delay: 2000,
                  disableOnInteraction: false,
                }}
                freeMode={true}
                modules={[FreeMode, Autoplay]}
                loop={true}
              >
                {data?.gallery?.map((el, i) => (
                  <SwiperSlide key={i}>
                    <div className="newsDiv">
                      <img
                        className="w-100"
                        alt={el.image_title}
                        src={el.image}
                      />
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
              <h2 className="main-color my-3">{data.title}</h2>
              <div className="mb-2 d-flex justify-content-between wrap">
                <p>
                  <span className="fw-bold">{t("gen.owner")}</span> :{" "}
                  <span className="main-color">{data.owner}</span>
                </p>
                <p>
                  <span className="fw-bold">{t("gen.client")}</span> :{" "}
                  <span className="main-color">{data.client}</span>
                </p>
                <p>
                  <span className="fw-bold">{t("gen.area")}</span> :{" "}
                  <span className="main-color">{data.area}</span>
                </p>
                <p>
                  <span className="fw-bold">{t("gen.date")}</span> :{" "}
                  <span className="main-color">{data.date}</span>
                </p>
              </div>
              {React.createElement("div", {
                className: "text-justify mb-2",
                dangerouslySetInnerHTML: { __html: data.description },
              })}
            </div>
          </div>
        </section>
      )}
    </>
  );
}
